module.exports = "/assets/data/fd0e49e9983e70e8d7cfe84d3cb43d20-EN8.data.json";